import React, { useContext, useState } from "react";
import { ResultsTournamentContext } from "@state/context/results";
import { openTournamentStatistics } from "@utils";
import classnames from "classnames";

export default function ResultsTournamentStatisticsButton() {
	const tournament = useContext(ResultsTournamentContext);

	const shouldDisplayStatisticsButton =
		tournament.source != null &&
		tournament.source.providerId != null &&
		tournament.source.providerId !== "";

	const [isHover, setIsHover] = useState(false);

	if (shouldDisplayStatisticsButton) {
		return (
			<th className="table--results__subheader__data table--results__subheader__data--stats">
				<button
					className="btn btn--square--reset btn--ghost"
					type="button"
					onClick={() => {
						if (tournament.source?.providerId) {
							openTournamentStatistics(
								tournament.source.providerId
							);
						}
					}}
					onMouseEnter={() => setIsHover(true)}
					onMouseLeave={() => setIsHover(false)}
				>
					<i
						className={classnames("u-icon u-icon--sml", {
							"u-icon--action--stats--active": !isHover,
							"u-icon--action--stats--selected": isHover,
						})}
					/>
				</button>
			</th>
		);
	}

	return (
		<th className="table--results__subheader__data table--results__subheader__data--stats" />
	);
}
